module.exports = __webpack_public_path__ + "img/7.25646553.jpg";